import { Scissors, Clock, Shield, Sparkles, Car, CalendarCheck } from "lucide-react";

const VAN_URL = "https://customer-assets.emergentagent.com/job_barber-membership-1/artifacts/rvy2rpaa_20210411_153748.jpg";

const services = [
  {
    icon: Scissors,
    title: "Precision Cuts",
    description: "Fades, tapers, lineups, and more. Our barbers specialize in modern styles for professionals.",
  },
  {
    icon: Car,
    title: "Mobile Service",
    description: "We arrive at your home, office, or gym. Fully equipped mobile barber setup with premium tools.",
  },
  {
    icon: Clock,
    title: "On Your Time",
    description: "Early morning, lunch break, or evening. We work around your schedule, not the other way around.",
  },
  {
    icon: Shield,
    title: "Consistent Quality",
    description: "Same skilled barber every visit. Build a relationship and get cuts tailored to your style.",
  },
  {
    icon: Sparkles,
    title: "Premium Products",
    description: "We use only top-tier grooming products. Hot towel finish, beard oil, and styling included.",
  },
  {
    icon: CalendarCheck,
    title: "Membership Perks",
    description: "Priority booking, exclusive seasonal styles, and complimentary grooming products for members.",
  },
];

export default function ServiceHighlights() {
  return (
    <section data-testid="services-section" className="relative py-24 md:py-32 bg-[#0A0A0B]">
      <div className="px-6 md:px-12 lg:px-24">
        {/* Header */}
        <div className="max-w-2xl mb-16">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-px w-12 bg-[#C5A059]" />
            <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#C5A059]">
              What We Offer
            </span>
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl tracking-tight font-medium text-[#F3F4F6] mb-4">
            Elite grooming, delivered
          </h2>
          <p className="text-base text-[#A1A1AA] leading-relaxed font-light">
            Everything you need for a premium grooming experience, brought directly to your location in the San Francisco Bay Area.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, i) => (
            <div
              key={i}
              data-testid={`service-${i}`}
              className="group p-8 rounded-md bg-[#141416] border border-white/5 hover:-translate-y-1 hover:border-white/15 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-sm bg-[#C5A059]/10 flex items-center justify-center mb-5 group-hover:bg-[#C5A059]/20 transition-colors duration-300">
                <service.icon className="w-6 h-6 text-[#C5A059]" />
              </div>
              <h3 className="font-heading text-xl tracking-tight font-medium text-[#F3F4F6] mb-3">
                {service.title}
              </h3>
              <p className="text-sm text-[#A1A1AA] leading-relaxed font-light">
                {service.description}
              </p>
            </div>
          ))}
        </div>
        {/* Mobile Studio Showcase */}
        <div className="mt-16 rounded-md overflow-hidden border border-white/5 relative group">
          <div className="grid md:grid-cols-2">
            <div className="relative overflow-hidden">
              <img
                src={VAN_URL}
                alt="LUXGROOM Mobile Barber Van"
                data-testid="van-image"
                className="w-full h-full object-cover min-h-[280px] md:min-h-[320px] group-hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="p-8 md:p-10 bg-[#141416] flex flex-col justify-center">
              <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#C5A059] mb-3">
                Our Mobile Studio
              </span>
              <h3 className="font-heading text-xl sm:text-2xl tracking-tight font-medium text-[#F3F4F6] mb-3">
                A full barbershop on wheels
              </h3>
              <p className="text-sm text-[#A1A1AA] leading-relaxed font-light">
                Our custom-fitted Mercedes Sprinter van is a fully equipped mobile barbershop — 
                climate-controlled, sanitized, and stocked with premium tools and products. 
                The same quality you'd expect from a top-tier shop, delivered to your location.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="section-divider mt-24 mx-6 md:mx-12 lg:mx-24" />
    </section>
  );
}
